import {
    ConvertedToObjectType,
    TranslationJsonType,
} from '@internal/utils/machine/i18n/Translation';

export const translations: ConvertedToObjectType<TranslationJsonType> =
    // biome-ignore lint/suspicious/noExplicitAny: legacy
    {} as any;

/*
 * Converts the static JSON file into an object where keys are identical
 * but values are strings concatenated according to syntax.
 * This is helpful when using the JSON file keys and still having the intellisense support
 * along with type-safety
 */
// biome-ignore lint/suspicious/noExplicitAny: legacy
export const convertLanguageJsonToObject = (json: any) => {
    for (const key in json) {
        translations[key] = key;
    }
};
